import {
  CrossClientQueryClientQueryMode,
  CrossClientQueryClientQueryModes,
  CrossClientQueryDecision,
  CrossClientQueryResultMatch,
  CrossClientQueryResultMatches,
} from '../../models/CrossClient'
import { getUserDisplayName } from '../../apps/professional-app/fa/common/aifeatures/utils'
import { User } from '../../models/User'

export const CLIENT_MODE_LABEL: Record<CrossClientQueryClientQueryMode, string> = {
  [CrossClientQueryClientQueryModes.ONLY_OWNED]: 'Yours only',
  [CrossClientQueryClientQueryModes.WITH_SHARED]: 'Yours + Shared',
  [CrossClientQueryClientQueryModes.ALL_AVAILABLE]: 'All available',
}

export const mapEvaluatedDecisionToMatch = (decision: CrossClientQueryDecision): CrossClientQueryResultMatch => {
  if (decision === null) {
    return CrossClientQueryResultMatches.PARTIAL
  }
  return decision ? CrossClientQueryResultMatches.MATCH : CrossClientQueryResultMatches.NO_MATCH
}

export const getOwnerLabel = (currentUser: User, teammates: Record<string, User>, ownerId: string | null) => {
  if (!ownerId) {
    return '-'
  }
  if (ownerId === currentUser.id) {
    return `${getUserDisplayName(currentUser)} (You)`
  }
  const owner = teammates[ownerId]
  return owner ? getUserDisplayName(owner) : '-'
}
